import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Heart, Calendar, Info, HelpCircle, Shield, FileText } from 'lucide-react';
import { Button } from './ui/button';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetHeader,
  SheetTitle,
} from "./ui/sheet";
import VisitorCounter from './VisitorCounter';

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);

  const navLinks = [
    { name: 'Cycle Calculator', path: '/cycle-calculator', icon: Calendar },
    { name: 'About', path: '/about', icon: Info },
    { name: 'Help & Support', path: '/help', icon: HelpCircle },
    { name: 'Privacy Policy', path: '/privacy', icon: Shield },
    { name: 'Terms of Service', path: '/terms', icon: FileText },
  ];

  const NavItems = ({ mobile = false }) => (
    <>
      {navLinks.map((link) => (
        <Link
          key={link.path}
          to={link.path}
          onClick={() => mobile && setIsOpen(false)}
          className={`flex items-center space-x-2 transition-colors ${
            location.pathname === link.path
              ? 'text-[#FF6B9D] font-bold'
              : 'text-gray-700 hover:text-[#FF6B9D]'
          } ${mobile ? 'text-lg py-3 border-b border-pink-50' : ''}`}
        >
          {mobile && <link.icon className="w-5 h-5" />}
          <span>{link.name}</span>
        </Link>
      ))}
      <Link
        to="/contribute"
        onClick={() => mobile && setIsOpen(false)}
        className={`flex items-center text-[#FF6B9D] font-bold hover:scale-105 transition-all ${
          mobile ? 'text-lg py-3' : ''
        }`}
      >
        <Heart className={`w-4 h-4 mr-2 ${mobile ? 'w-5 h-5' : ''} fill-[#FF6B9D]`} />
        Contribute
      </Link>
    </>
  );

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-pink-100">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_ovalu-design/artifacts/231iio5y_1000063769.jpg"
              alt="Ovalu Logo"
              className="h-10 w-10 md:h-12 md:w-12 rounded-2xl"
            />
            <span className="text-2xl font-bold text-[#FF6B9D]">ovalu</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <NavItems />
            <div className="pl-4">
              <VisitorCounter />
            </div>
          </nav>

          {/* Mobile Navigation */}
          <div className="flex items-center space-x-4 lg:hidden">
            <div className="hidden sm:block">
               <VisitorCounter />
            </div>
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-[#FF6B9D]">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px] border-l-pink-100">
                <SheetHeader className="text-left mb-8">
                  <SheetTitle className="flex items-center space-x-3">
                    <img
                      src="https://customer-assets.emergentagent.com/job_ovalu-design/artifacts/231iio5y_1000063769.jpg"
                      alt="Ovalu Logo"
                      className="h-10 w-10 rounded-xl"
                    />
                    <span className="text-2xl font-bold text-[#FF6B9D]">ovalu</span>
                  </SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col space-y-4">
                  <NavItems mobile />
                  <div className="pt-8 sm:hidden">
                    <VisitorCounter />
                  </div>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
